import axios from "axios";
import { config } from "../configs";
import { getSessionToken } from "./getToken";

// import { customers } from "../__mocks__";

const createCustomer = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/customers`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

// const getOrgCustomer = async (orgs, index = 0, customers = []) => {
//   return new Promise(async function (resolve, reject) {
//     try {
//       if (orgs.length === 0) {
//         resolve([]);
//       } else {
//         const jwtToken = await getSessionToken();
//         const URL = `${config.baseURL}/organizations/${orgs[index]?.id}/customers`;
//         const { data } = await axios({
//           method: "GET",
//           headers: {
//             Authorization: jwtToken,
//             Application: "Platform",
//             Organization: orgs[index]?.id,
//           },
//           url: URL,
//         });
//         // to be done from API
//         let newData = data.map((item) => ({
//           ...item,
//           orgId: orgs[index]?.id,
//           orgName: orgs[index]?.name,
//         }));
//         customers = [...customers, ...newData];
//         if (index >= Array.from(orgs).length - 1) return resolve(customers);
//         return resolve(await getOrgCustomer(orgs, index + 1, customers));
//       }
//     } catch (error) {
//       reject(error);
//     }
//   });
// };

const getUserCustomers = async () => {
  const jwtToken = await getSessionToken();
  const orgID = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
        ?.id
    : undefined;
  return new Promise(async function (resolve, reject) {
    try {
      const URL = `${config.baseURL}/organizations/current/customers`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getCustomer = async (orgId, customerId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const addContact = async (attributes, orgId, customerId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/contacts`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteCustomerContact = async (orgId, customerId, contactId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/contacts/${contactId}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteCustomerCustomer = async (orgId, customerId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateCustomerContact = async (
  orgId,
  customerId,
  contactId,
  attributes
) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/contacts/${contactId}`;
      const { status } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(status);
    } catch (error) {
      reject(error);
    }
  });
};

// Places
const getCustomerPlaces = async (orgId, customerId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/customers/${customerId}/places`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      // to be done from API
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getCustomerPlace = async (orgId, customerId, placeId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      let URL = "";
      if (String(customerId)?.split("").length < 5) {
        URL = `${config.baseURL}/organizations/current/places/${placeId}`;
      } else {
        URL = `${config.baseURL}/organizations/current/customers/${customerId}/places/${placeId}`;
      }

      const response = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      // resolve(orgPlaces);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const addNewCustomerPlace = async (orgId, customerId, attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/places`;
      const response = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(response?.status);
    } catch (error) {
      reject(error);
    }
  });
};

const updateCustomerPlace = async (orgId, customerId, placeId, attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/organizations/current/customers/${customerId}/places/${placeId}`;
      const response = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(response?.status);
    } catch (error) {
      reject(error);
    }
  });
};

// client profile image
const getClientImagePutUrl = async (orgId, customerId, fileType) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/organizations/current/customers/${customerId}/imageurls/put`;

      const response = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        params: {
          fileType,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const putClientImage = async (putUrl, file, filetype) => {
  return new Promise(async function (resolve, reject) {
    try {
      const response = await axios.put(putUrl, file, {
        headers: {
          "Content-Type": `image/${filetype}`,
          "Access-Control-Allow-Origin": '*'
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  createCustomer,
  getUserCustomers,
  getCustomer,
  addContact,
  deleteCustomerContact,
  updateCustomerContact,
  deleteCustomerCustomer,
  getCustomerPlace,
  getCustomerPlaces,
  addNewCustomerPlace,
  updateCustomerPlace,
  getClientImagePutUrl,
  putClientImage
};
